import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { Applicant, ApplicationFormData } from '../models';

export interface ApplicantApi {
    items: Applicant[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicantService {
    private _applicantsRoute = '/api/applicants/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public applicantBeingViewed: any = {};
    public storedApplicationData: ApplicationFormData = null;

    // https://www.google.com/recaptcha/admin/site/450974701/settings

    public siteKey: string = '6LcjxbcqAAAAAC8wHfFv3uA2r_MIBgo41LuJ5-1g';
    public secretKey: string = '6LcjxbcqAAAAAJOji2rrd66b3RZZbdRRnfVQiMF5';

    // for old creds
    // public siteKey: string = '6Le0PxwTAAAAAH5fQTQNMMF5wv5RPz8LtwdBzyPY';
    // public secretKey: string = '6Le0PxwTAAAAAJowkgcpGnPbwt8xsmntyaXI-siJ';

    constructor(
        private httpClient: HttpClient,
    ) { }


    setApplicantToBeViewed(_applicant: any) {
        this.applicantBeingViewed = _applicant;
    }


    getApplicantToBeViewed() {
        return this.applicantBeingViewed;
    }


    setStoredApplicationData(_application: any) {
        this.storedApplicationData = _application;
    }


    getStoredApplicationData() {
        return this.storedApplicationData;
    }


    get(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._applicantsRoute);
    }


    getById(_applicantId: string): Observable<any> {
        return this.httpClient.get<any>(this._applicantsRoute + _applicantId);
    }


    create(_applicant: Applicant): Observable<any> {
        return this.httpClient.post<any>(this._applicantsRoute, JSON.stringify(_applicant), this.headerOptions);
    }


    sendToYeehro(_yeehroDetails: any): Observable<any> {
        // applicant, file
        return this.httpClient.post<any>(this._applicantsRoute + 'send-to-yeehro', JSON.stringify(_yeehroDetails), this.headerOptions);
    }


    verifyCaptcha(_responseKey: any): Observable<any> {
        return this.httpClient.post<any>(this._applicantsRoute + 'verify/captcha', JSON.stringify(_responseKey), this.headerOptions);
    }


    selectAllSearch(searchTerms: Applicant): Observable<ApplicantApi> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<ApplicantApi>(this._applicantsRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<ApplicantApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
        searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
        searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;
    
        return this.httpClient.post<ApplicantApi>(this._applicantsRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
    }


    doAdvancedSearch(searchTerms): Observable<any> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post(this._applicantsRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    update(_applicant: Applicant): Observable<any> {
        return this.httpClient.put<any>(this._applicantsRoute + _applicant._id, JSON.stringify(_applicant), this.headerOptions);
    }


    markDelete(_id: string): Observable<any> {
        return this.httpClient.put(this._applicantsRoute + 'mark-deleted/' + _id, this.headerOptions);
    }
}